/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-27 11:06:20                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-23 10:54:49                               *
 *****************************************************************************/


/* SUMMARY
  * Imports
  * TechnicianInfoCard: display technician entity informations
*/

/* Imports */
import { Card, CardBody, Typography } from "@material-tailwind/react";
import { EnvelopeIcon } from "@heroicons/react/24/solid";
import { secondsToStringTime, toSinceString } from "../../../services/utils/utils";
import { t } from "../../../i18n";
/***/

/**
* TechnicianInfoCard: display technician entity informations
* @param technician - technician data to display
*/
export default function TechnicianInfoCard({
  technician
}: {
  technician: EasyTech.Technician
}) {

  return (
    <Card className="m-3">
      <CardBody className="flex justify-between">
        <div  className="flex flex-col">
          <Typography variant={"h6"} className="mb-2">
            { `${technician.firstName} ${technician.lastName}` }
          </Typography>
          <div className="flex gap-2">
            <div className="flex items-center justify-center">
              <EnvelopeIcon className="h-[20px] w-[20px] text-gray-400"/>
            </div>

            <Typography>{technician.email}</Typography>
          </div>
        </div>

        <div  className="flex flex-col justify-center">

          {technician.itinerary && technician.itinerary.travelTime ?
            <>
              <Typography variant="small"
                          className="text-gray-900">
                {secondsToStringTime(technician.itinerary.travelTime.inSeconds)} &middot; {technician.itinerary.distance.humanReadable}
              </Typography>


              <Typography variant="small"
                          className="text-gray-500">
                {t("about:app.updated")} {toSinceString(technician.itinerary.updated)}
              </Typography>
            </>
          :
            <Typography variant="small"
                          className="text-gray-900">
              {t("technician:noItinerary")}
            </Typography>
          }
        </div>

      </CardBody>
    </Card>
  );
}
/***/
